/* eslint-disable no-undef */
(function (root, factory) {
    if (typeof module === 'object' && module.exports) {
        module.exports = factory(
            require('backbone'),
            require('jquery'),
            require('cookies-js'),
        );
    } else if (typeof define === 'function' && define.amd) {
        define(['backbone', 'jquery'], function (Backbone, $) {
            return factory(Backbone, $, {
                expire: $.removeCookie,
                set: $.cookie,
            });
        });
    }
})(this, function (Backbone, $, Cookies) {
    'use strict';

    var COOKIE = 'ebfp_e';

    return Backbone.Model.extend({
        config: {
            url: '/ajax/fp.x',
        },

        getValue: function () {
            var $deferred = new $.Deferred();

            // Signal read mode.
            Cookies.expire(COOKIE);
            $.ajax(this.config.url)
                .done(function (data) {
                    // The server will respond with an empty string if the
                    // If-None-Match header is not set.
                    $deferred.resolve(data);
                })
                .fail(function () {
                    $deferred.resolve('');
                });

            return $deferred.promise();
        },

        setValue: function (value) {
            var $deferred = new $.Deferred();

            // Signal write mode
            Cookies.set(COOKIE, value, { path: '/' });

            // In case cookies are not set, also set in the headers
            // Can likely remove setting cookies in the future, but
            // we leave it here for now for backwards compatibility
            $.ajax({
                url: this.config.url,
                headers: {
                    'x-eb-fb': value,
                },
            })
                .done(function () {
                    Cookies.expire(COOKIE);
                    $deferred.resolve(true);
                })
                .fail(function () {
                    $deferred.reject();
                });

            return $deferred.promise();
        },
    });
});
